export default {
  getCurrent (tableId, cb, errorCb) {
    axios.get('/dragontiger/' + tableId + '/current')
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },

  getStats (tableId, cb, errorCb) {
    axios.get('/dragontiger/' + tableId + '/stats')
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },

  sendBet: _.throttle((tableId, gameId, post, cb, errorCb) => {
    const request = {
      table_id: tableId,
      game_id: gameId,
      chip: post
    }
    axios.defaults.headers.common['Content-Type'] = 'application/vnd.api+json'
    axios.post('/bet/dragontiger', request)
      .then(response => {
        cb(response)
      })
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  }, 100, { 'leading': false })
}



// WEBPACK FOOTER //
// ./resources/assets/js/dragon/api/dragon.js